import { get_areas } from '../../../../Services/area'

//Função que traz os dados do banco de dados
export const get = () =>{
    return[(dispatch,getState)=>{
        const order = getState().area.order
        const th = getState().area.th
        const qtd_per_page = getState().area.qtd_per_page
        const pesquisa = getState().area.pesquisa || '' 
        const page = getState().area.page      
      
        get_areas(page,qtd_per_page,order,th,pesquisa)
        .then(resp=>dispatch({type:'Areas', payload:resp.data}))

    }]
}

//Função que ordena as colunas
export const order = (coluna) => {
    return [(dispatch,getState)=>{
        const asc = getState().area.asc
      
        if(asc === true){
            dispatch({type:'GetAreas_Desc', desc:true, asc:false,order:'desc',th:coluna})
            
        }if(asc === false){
            dispatch({type:'GetAreas_Asc', asc:true, desc:false,order:'asc',th:coluna})
            
        }
     
    },get(1)]    
}

export const change_qtd_per_page = event => {
    return[{
        type:'qtd_per_page_area',
        payload:event.target.value
    },get(1)]
}

export const changePesquisa = event => {
    return[{
        type:'pesquisaArea',
        payload:event.target.value
    }]
}

export const clearPesquisa = event => {
    return[{
        type:'clearPesquisaArea',
        payload:''
    },get(1)]
}

export const changePage = page => {
    return[{
        type: 'changePageArea',
        payload: page
    },get()]
}

export const search = () => {
    return [
        (dispatch, getState) => {
            const pesquisa = getState().area.pesquisa || ''
            if(pesquisa){
                return dispatch({type:'changePageArea', payload:1})
            }
        }, get()
    ]
}

